<template>
    <div>
        <v-card-title>AI: расходы</v-card-title>

        <v-row v-if="loading">
            <v-col cols="12" md="7">
                <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-col>
        </v-row>

        <v-card v-if="!loading" class="mb-4">
            <v-card-title>
                Расход за сегодня
                <v-spacer></v-spacer>
                <v-btn icon @click="fetchBudget()"><v-icon>mdi-refresh</v-icon></v-btn>
            </v-card-title>
            <v-card-text v-if="budget">
                <div class="mb-2">
                    ${{ budget.spentTodayUsd }} из ${{ budget.dailyLimitUsd }}
                </div>
                <v-progress-linear
                    :value="budget.dailyLimitUsd > 0 ? (budget.spentTodayUsd / budget.dailyLimitUsd * 100) : 0"
                    height="14" :color="budget.limitReached ? 'red' : 'green'">
                </v-progress-linear>
                <v-alert v-if="budget.limitReached" type="warning" dense class="mt-3">
                    Дневной лимит расходов на AI достигнут.
                </v-alert>
            </v-card-text>
        </v-card>

    </div>
</template>

<script>
import AiService from "../_services/AiService";
import {mapState} from 'vuex';

export default {
    name: "AiBudget",
    data() {
        return {
            loading: true,
            budget: null
        }
    },
    computed: {
        ...mapState(['user'])
    },
    methods: {
        fetchBudget() {
            this.loading = true;
            AiService.getBudgetToday().then(data => {
                this.budget = data;
                this.loading = false;
            });
        }
    },
    created() {
        this.fetchBudget();
    }
};
</script>
